/**
 * A module to handle min/max values for a tab box. This module is used to
 * check that the min value is less than the max value and vice versa. It changes
 * the value of the min/max input if the value is less than the min/max value.
 */

class MinMaxTabBox {
  /**
   *
   * @constructor
   * @param {NodeList} [minMaxElement] - minMaxElement.
   */
  constructor(minMaxElement) {
    this.element = minMaxElement;
    this.radioButtons = this.element.querySelectorAll('input[type="radio"]');
    this.fieldSets = this.element.querySelectorAll('fieldset');

    this.radioButtons.forEach(radioButton => {
      this.#checkMinMaxValues(radioButton);
    });
  }

  /**
   * Check the min/max values of the input fields and update the values if necessary.
   * @param {htmlElement} radioButton - The radio button element.
   * @private
   */
  #checkMinMaxValues(radioButton) {
    const radioButtonId = radioButton.id;
    const minInput = this.element.querySelector(`input[type="number"][id="${radioButtonId}_min"]`);
    const maxInput = this.element.querySelector(`input[type="number"][id="${radioButtonId}_max"]`);

    radioButton.addEventListener('click', ({ target }) => {
      // Disable the fieldset that is not active, and enable the one that is, by checking if the id of the radiobutton matches with the fieldsets -content id.
      // This makes it so that the hidden tab is excluded from the search filter form and not included in the search
      this.fieldSets.forEach(fieldset => fieldset.toggleAttribute('disabled', `${target.id}-content` !== fieldset.id));
    });

    this.#inputEventListeners(minInput, maxInput);
  }

  /**
   * Add event listeners to the min/max input fields.
   * @param {htmlElement} minInput - The min input field.
   * @param {htmlElement} maxInput - The max input field.
   * @private
   */
  #inputEventListeners(minInput, maxInput) {
    minInput.addEventListener('change', () => {
      const minValue = Math.max(parseInt(minInput.min), Math.min(parseInt(minInput.value), parseInt(minInput.max)));
      minInput.value = maxInput.value > 0 ? Math.min(minValue, parseInt(maxInput.value)) : minValue;
    });

    maxInput.addEventListener('change', () => {
      const maxValue = Math.min(parseInt(maxInput.max), Math.max(parseInt(maxInput.value), parseInt(maxInput.min)));
      maxInput.value = minInput.value > 0 ? Math.max(maxValue, parseInt(minInput.value)) : maxValue;
    });
  }
}

export { MinMaxTabBox };
